import { useEffect, useState } from 'react';
import { resolveImage } from "../../images/ImageResolver";
import WealthPackages from './WealthPackages';
import HighLevel from './HighLevel';
import MidLevel from './MidLevel';
import { FilterInput, RowFiltering, AutoTooltip } from '@refinitiv-ui/efx-grid/extensions';
import { fetchData, textWithIcon, styles } from './Helpers';

export default function Muni() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [view, setView] = useState("default");

  useEffect(() => {
    fetchData("Filings_Muni").then(res => {
      setData(res);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    const grid = document.getElementById("grid");
    const filterInputExt = new FilterInput();
    const rowFilteringExt = new RowFiltering();
    const autoToolTipExt = new AutoTooltip();
    const columns = [
      { name: 'Document Type', field: 'documentType', leftPinned: true, scalable: true},
      { name: 'Submission Type Code', field: 'gstCode', scalable: true,styles: styles },
      { name: 'Submission Type', field: 'stdValue', scalable: true},
      { name: 'High Level Category ID', field: 'highLevelId', scalable: true, headerBinding: headerWithLink1,styles: styles },
      { name: 'High Level Category', field: 'highLevelCategory', scalable: true},
      { name: 'Mid Level Category ID', field: 'midLevelId', scalable: true, headerBinding: headerWithLink1,styles: styles },
      { name: 'Mid Level Category', field: 'midLevelCategory', scalable: true},
      { name: 'PUBLIC', field: 'public', scalable: true, filterInput: false, headerBinding: headerWithLink.bind(null, "Non Professional", "free"),binding: textWithIcon.bind(null, "yes"),styles: styles },
      { name: 'PRIVATE', field: 'private', scalable: true, filterInput: false, headerBinding: headerWithLink.bind(null, "Non Professional", "private"),binding: textWithIcon.bind(null, "yes")},
      { name: 'INTERNAL PROFESSIONAL', field: 'professional', scalable: true, filterInput: false, headerBinding: headerWithLink.bind(null, "Private", "professional"), binding: textWithIcon.bind(null, "yes"), styles: styles}
    ]

    function headerWithLink(text, i, e) {
      let cell = e.cell;
      let content = cell.getContent();
      if(!content || !content._myHeaderWithLink) {
        content = document.createElement("div");
        content._myHeaderWithLink = true;
        let span = content._span = document.createElement("span");
        span.style.marginRight = "5px";
        let link = content._link = document.createElement("ef-icon");
        link.icon = "link";
        link.style.color = "blue";
        content.addEventListener("click", function(arg) {
          arg.stopPropagation();
          setView("wealth");
        });
        let image = content._span1 = document.createElement("img");
        image.style.position = "absolute";
        image.style.top = "10px";
        image.style.right = "5px";
        image.style.width = "38px";
        image.src = resolveImage(i);
        let span2 = content._span2 = document.createElement("span");
        span2.style.display = "block";
        span2.style.fontWeight = 400;
        content.appendChild(span);
        content.appendChild(link);
        content.appendChild(span2);
        content.appendChild(image);
      }

      content._span.textContent = e.columnDef.getName();
      content._span2.textContent = text;
      cell.setContent(content);
    };

    function headerWithLink1(e) {
      let cell = e.cell;
      let content = cell.getContent();
      if(!content || !content._myHeaderWithLink) {
        content = document.createElement("div");
        content._myHeaderWithLink = true;
        let span = content._span = document.createElement("span");
        span.style.marginRight = "5px";
        let link = content._link = document.createElement("ef-icon");
        link.icon = "link";
        link.style.color = "blue";
        content.addEventListener("click", function(arg) {
          arg.stopPropagation();
          if(e.columnDef.getName() === "High Level Category ID") {
            setView("highLevel");
          }
          if(e.columnDef.getName() === "Mid Level Category ID") {
            setView("midLevel");
          }
        });
        content.appendChild(span);
        content.appendChild(link);
      }

      content._span.textContent = e.columnDef.getName();
      cell.setContent(content);
    }

    function gridConfigured(e) {
      const core = e.detail.api.getCoreGrid();
      core.setColumnWidths([150, 180, 200, 180, 200, 180, 200, 250, 250, 250], false);
    }

    if(view === "default") {
      grid.config = {
        rowHeight: 60,
        headerRowHeight: 60,
        autoHideScrollbar: false,
        columns: columns,
        dataModel: {
          data: data
        },
        sorting: {
          sortableColumns: false,
          initialSort: {
              colIndex: 0, // Column index
              sortOrder: "a"
          }
        },
        rowFiltering: {
          disabledUI: true
        },
        autoTooltip: {
          title: true
        },
        extensions: [
          rowFilteringExt,
          filterInputExt,
          autoToolTipExt
        ]
      };
      grid.addEventListener('configured', gridConfigured);
    }
  }, [data, view]);

  return (
    <div className='main-div'>
      <ef-loader class="loader" hidden={!loading}></ef-loader>
      {view === "wealth" && (
        <div>
          <ef-button className="back-button" icon="back" onClick={() => setView("default")}>Back</ef-button>
          <WealthPackages />
        </div>
      )}
      {view === "highLevel" && (
        <div>
          <ef-button className="back-button" icon="back" onClick={() => setView("default")}>Back</ef-button>
          <HighLevel />
        </div>
      )}
      {view === "midLevel" && (
        <div>
          <ef-button className="back-button" icon="back" onClick={() => setView("default")}>Back</ef-button>
          <MidLevel />
        </div>
      )}
      {view === "default" && (
        <div>
          <h4>Muni</h4>
          <p className='commentP'>This is the Manual collection feed where documents are sourced directly by analysts or semi automated solutions like Sparrow and Kapow.</p>
          <efx-grid id="grid" className="filings-grid"></efx-grid>
        </div>
      )}
    </div>
  );
}